/**
 * Checks if a dropdown interaction is currently happening.
 * This prevents modals and drawers from closing when clicking on dropdown portals.
 */
export const hasDropdownInteraction = (): boolean => {
  if (document.body.hasAttribute('data-dropdown-interaction')) {
    return true;
  }

  const dropdown = document.querySelector('[data-select-dropdown="true"]');

  return !!dropdown;
};

/**
 * Temporarily sets the dropdown interaction attribute on the body.
 * This prevents modals and drawers from closing when clicking on dropdown portals.
 * The attribute is automatically removed after 150ms.
 */
export const setDropdownInteraction = (): void => {
  document.body.setAttribute('data-dropdown-interaction', 'true');
  setTimeout(() => {
    document.body.removeAttribute('data-dropdown-interaction');
  }, 150);
};

/**
 * Helper to handle Dialog/Drawer onOpenChange events.
 * Prevents closing when there's an active dropdown interaction.
 */
export const handleDropdownAwareClose = (
  open: boolean,
  onClose: () => void
): void => {
  if (!open && !hasDropdownInteraction()) {
    onClose();
  }
};

